import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EMobiledataIcon(props: IconProps) {
    return <Icon {...props} iconKey={"e_mobiledata"}/>
}
